import React from 'react';
import BetaChip from '../common/BetaChip/BetaChip';
import TripEconomistDetails from '../TripEconomistDetails/TripEconomistDetails';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import './ChokeStockAnalysis.css';

export default function ChokeStockAnalysis(
  props: RegistryComponentProps
): React.ReactElement {
  return (
    <div className="choke-stock-analysis insight-card">
      <div className="insight-title-row">
        <h3>Choke Stock Analysis <BetaChip /></h3>
      </div>
      <div className="insight-columns">
        <TripEconomistDetails />
      </div>
    </div>
  );
}
